export enum Pages {
  landing = 'landing',
  home = 'home',
  missions = 'missions',
  game = 'game',
  redeem = 'redeem',
  redeemHistory = 'redeemHistory',
  welcomeGift = 'welcomeGift',
  survey = 'survey',
  welcomeGiftCongrats = 'welcomeGiftCongrats',
  levels = 'levels',
}

export enum Tabs {
  Levels = 'Levels',
  DemoReferral = 'DemoReferral',
  Redeem = 'Redeem',
  WelcomeGift = 'WelcomeGift',
  Missions = 'Missions',
  Referral = 'Referral',
  Game = 'Game',
  LivePromotion = 'LivePromotion',
  Campaign = 'Campaign'
}
